const routes = {
  createSection: 'section',
  getSections: 'section',
  getSectionById: 'section/',
  updateSection: 'section/',
  deleteSection: 'section/',
};

export default routes